import React, { Component } from 'react';
import axios from 'axios';

export function withCancellablePromise(WrappedComponent, operationName = 'request') {
  return class WrappedPage extends Component {
    constructor(props) {
      super(props);
      this.state = {
        source: axios.CancelToken.source()
      };
    }

    componentWillUnmount() {
      this.state.source.cancel(`Operation ${operationName} is cancelled`);
    }

    render() {
      return <WrappedComponent promiseCancelToken={this.state.source.token} {...this.props} />;
    }
  };
}
